/**
 * TODO: Specs for this TBD.
 */
export default class SignInView {

  #$el;
  #$signInButton;

  constructor() {
    this.#$el = $("#signInView");
    this.#$signInButton = this.#$el.find("#signInButton");
    this.#$signInButton.on("click tap", e => this.#onButton(e));
  }

  /**
   * Sign in button should remain hidden while waiting for gapi to initialize, mind.
   */
  show(shouldShowButton) {
    this.#$el.show();
    if (shouldShowButton) {
      this.#$signInButton.show();
      this.buttonEnabled = true;
    } else {
      this.#$signInButton.hide();
    }
  }

  set buttonEnabled(b) {
    const functionName = b ? "removeClass" : "addClass";
    this.#$signInButton[functionName]("disabled");
  }

  hide() {
    this.#$el.hide();
  }

  #onButton(e) {
    $(document).trigger("sign-in-button");
  }

}
